import { useState } from "react";
import { motion } from "framer-motion";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { SectionHeading } from "./SectionHeading";
import { ShareableCard } from "./ShareableCard";
import { fadeUp, viewportOnce } from "../../lib/motion";
import { useLang } from "../../i18n/LanguageContext";

const inputCls =
  "w-full rounded-xl border border-white/12 bg-white/5 px-4 py-3.5 text-white placeholder-white/35 outline-none transition-all focus:border-gold-light/60 focus:ring-2 focus:ring-gold-primary/30";

export const ShareCardSection = () => {
  const { t } = useLang();
  const s = t.sharecard;
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");

  return (
    <section id="share" data-testid="sharecard-section" className="relative overflow-hidden bg-ink-800 py-24 md:py-32 grain">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[360px] w-[520px] -translate-x-1/2 rounded-full bg-gold-primary/10 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} accent={s.accent} subtitle={s.subtitle} testid="sharecard-heading" />

        <div className="mt-14 grid items-start gap-10 lg:grid-cols-2">
          <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} className="lg:pt-6">
            <div className="glass rounded-3xl p-7 md:p-8">
              <label className="mb-2 block text-xs uppercase tracking-[0.15em] text-white/60">{s.nameLabel}</label>
              <input
                data-testid="sharecard-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={s.namePh}
                maxLength={22}
                className={inputCls}
              />
              <label className="mb-2 mt-6 block text-xs uppercase tracking-[0.15em] text-white/60">{s.catLabel}</label>
              <Select value={category} onValueChange={setCategory}>
                <SelectTrigger data-testid="sharecard-category" className={`${inputCls} h-auto justify-between`}>
                  <SelectValue placeholder={s.catPh} />
                </SelectTrigger>
                <SelectContent className="border-white/15 bg-ink-700 text-white">
                  {t.registration.categories.map((c) => (
                    <SelectItem key={c} value={c} className="focus:bg-gold-primary/20 focus:text-white">{c}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <p className="mt-6 text-sm leading-relaxed text-white/55">{s.subtitle}</p>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} className="mx-auto w-full max-w-sm">
            <ShareableCard name={name} category={category} />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
